package music.jammers.web.di

import music.jammers.client.shared.network.domain.model.ApiConfig
import music.jammers.web.domain.model.WebApiConfig
import org.koin.dsl.module

val networkModule = module {
    single<ApiConfig> {
        WebApiConfig()
    }
}